/*
  Decision: Partner Regex allows 2-24 characters for the TLD, therefore, we take the same value so we do not introduce inconsistencies between the two systems.

  https://azuredevops.at.zurich.com/Zurich/DiTRo/_workitems/edit/64287
*/
export function isEmail(value) {
    return /^(\w+([.\-+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,24})+)?$/.test(value || '');
}
